import { ElNotificationOptions } from 'element-ui/types/notification'

import Notification from '@/services/pushNotification/main.js'

const notification = (text: string, type: string) => {
  const options: ElNotificationOptions = {
    title: text,
    message: '',
    position: 'top-left',
    customClass: `${type}`,
    duration: type === 'error' ? 8000 : 3000,
    offset: 0,
  }
  Notification(options)
}

const notifications = (messages: string[], type: string) => {
  messages.forEach((message: string, index: number) => {
    setTimeout(() => notification(message, type), index * 100)
  })
}

export { notifications }
export default notification
